export function DetailRow({ label, value }) {
  return (
    <div className="flex justify-between py-2 border-b border-gray-50 text-xs">
      <span className="text-gray-400 font-medium">{label}:</span>
      <span className="font-semibold text-gray-700">{value || "N/A"}</span>
    </div>
  );
}